package org.lennycodes.hldi.components.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.borderBottom
import com.varabyte.kobweb.compose.css.textDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.signOut
import org.lennycodes.hldi.components.Routes
import org.lennycodes.hldi.components.logout
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.styles.ButtonStyle
import org.lennycodes.hldi.styles.DesktopNavDiv
import org.lennycodes.hldi.styles.DonateBtnStyle
import org.lennycodes.hldi.styles.LogoStyle
import org.lennycodes.hldi.styles.LogoTextStyle
import org.lennycodes.hldi.styles.MobileMenuStyle
import org.lennycodes.hldi.styles.MobileNavDiv
import org.lennycodes.hldi.styles.NavBarStyle
import org.lennycodes.hldi.styles.NavItemStyle

private val navItems = listOf(
    "Users" to Routes.admin,
    "About" to Routes.about,
    "Blog" to Routes.blog,
    "Events" to Routes.events,
    "Gallery" to Routes.gallery,
    "Resources" to Routes.resources
)

private const val MOBILE_MENU_ID = "mobile-nav-menu"

@OptIn(DelicateApi::class)
@Composable
fun AdminNavbar() {
    val ctx = rememberPageContext()
    val currentRoute = ctx.route.path
   val scope = rememberCoroutineScope()
    var isMenuOpen by remember { mutableStateOf(false) }

    Nav(
        attrs = Modifier
            .top(0.px)
            .left(0.px)
            .right(0.px)
            .padding(0.px, 24.px)
            .then(NavBarStyle.toModifier())
            .toAttrs()
    ) {
        A(
            href = "/",
            attrs = Modifier.then(LogoStyle.toModifier())
                .toAttrs()
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.px)
            ) {
                Img(
                    src = "/logo.webp",
                    alt = "RN-HLDI",
                    attrs = Modifier.size(width = 100.px, height = 70.px)
                        .toAttrs()
                )





            }
        }
        Div(
            attrs = Modifier
                .then(DesktopNavDiv.toModifier())
                .toAttrs()
        ) {
            navItems.forEach { (name, path) ->

                val isActive = currentRoute == path

                A(
                    href = path,
                    attrs = Modifier
                        .padding(12.px, 20.px)
                        .fontWeight(600)
                        .then(NavItemStyle.toModifier())
                        .toAttrs {
                            if (isActive) {
                                attr("aria-current", "page")
                                style {
                                    color(HLDITheme.Colors.primary)
                                    backgroundColor(HLDITheme.Colors.accent)
                                }
                            }
                        }
                ) {
                    Text(name)
                }
            }
        }

        Div(
            attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    gap(12.px)
                }
            }
        ) {
            com.varabyte.kobweb.silk.components.forms.Button(
                modifier = Modifier.padding(8.px).then(ButtonStyle.toModifier()),
                onClick = {
                    console.log("Logout clicked")
                    signOut(FirebaseService.auth)
                    ctx.router.navigateTo("/")
                }
            ) {
                Text("Logout")
            }

            Button(
                attrs = Modifier
                    .then(MobileNavDiv.toModifier())
                    .styleModifier {
                        property("background", "none")
                        property("border", "none")
                        property("appearance", "none")
                    }
                    .toAttrs {
                        attr("aria-expanded", isMenuOpen.toString())
                        attr("aria-controls", MOBILE_MENU_ID)
                        attr("aria-label", if (isMenuOpen) "Close menu" else "Open menu")
                        onClick { isMenuOpen = !isMenuOpen }
                    }
            ) {
                Text(if (isMenuOpen) "✕" else "☰")
            }
        }
    }

    // Mobile Menu
    if (isMenuOpen) {
        Div(
            attrs = Modifier
                .top(80.px)
                .left(0.px)
                .right(0.px)
                .padding(24.px)
                .gap(16.px)
                .then(MobileMenuStyle.toModifier())
                .toAttrs {
                    id(MOBILE_MENU_ID)
                }
        ) {
            navItems.forEach { (name, path) ->
                val isActive = window.location.pathname == path

                A(
                    href = path,
                    attrs = {
                        style {
                            color(HLDITheme.Colors.text)
                            textDecorationLine(TextDecorationLine.None)
                            fontSize(18.px)
                            fontWeight(600)
                            padding(12.px, 0.px)
                            borderBottom(1.px, LineStyle.Solid, Color.rgba(0, 0, 0, 0.1f))

                            if (isActive) {
                                color(HLDITheme.Colors.primary)
                            }
                        }
                        if (isActive) {
                            attr("aria-current", "page")
                        }
                        onClick { isMenuOpen = false }
                    }
                ) {
                    Text(name)
                }
            }
        }
    }
}